import React from 'react';
import Icon from '../../../components/_base/Icon';
import { Button } from '../../../components/_base/Button';
import { BOOKING_MESSAGES, BOOKING_BUTTON_LABELS, PRIMARY_COLOR } from '../../../lib/constants';

interface BookingSuccessContentProps {
  onClose: () => void;
  onOverlayClick: (e: React.MouseEvent) => void;
  formattedSpeakerNames?: string[];
  formattedDate?: string;
  startTimeEvent?: string;
  endTimeEvent?: string;
  transformedTimeZone?: string;
  showLocalTime?: boolean;
  startTimeLocal?: string;
  endTimeLocal?: string;
  isCancellation?: boolean;
  primaryColor?: string | null;
}

const BookingSuccessContent: React.FC<BookingSuccessContentProps> = ({
  onClose,
  onOverlayClick,
  formattedSpeakerNames = [],
  formattedDate,
  startTimeEvent,
  endTimeEvent,
  transformedTimeZone,
  showLocalTime = false,
  startTimeLocal,
  endTimeLocal,
  isCancellation = false,
  primaryColor
}) => {
  const message = isCancellation ? BOOKING_MESSAGES.CANCELLATION_SUCCESS : BOOKING_MESSAGES.SUCCESS;
  const hasBookingDetails = formattedDate && startTimeEvent && endTimeEvent;
  const appliedColor = primaryColor || PRIMARY_COLOR;
  const customStyle = { '--primary-color': appliedColor } as React.CSSProperties;

  return (
    <div className="booking-confirmation-modal-overlay" onClick={onOverlayClick} role="dialog" aria-modal="true" style={customStyle}>
      <div className="booking-confirmation-modal">
        <div className="close-button-container">
          <button type="button" className="close-button" onClick={onClose} aria-label="Close">
            <Icon.Remove width="15" height="15" viewBox="0 0 24 24" />
          </button>
        </div>
        <div className="confirmation-content">
          <div className="confirmation-message">
            {!isCancellation && (
              <div className="confirmation-icon">
                <Icon.CheckmarkCircleIcon fill={appliedColor} />
              </div>
            )}
            <div className="confirmation-message-content">
              <p className="main-message">
                {message}
              </p>
              {formattedSpeakerNames.length > 0 && formattedSpeakerNames.map((line, index) => (
                <p key={`${line}-${index}`} className="with-speaker">
                  {index === 0 && 'with '}
                  <strong>{line}</strong>
                </p>
              ))}
              {hasBookingDetails && (
                <>
                  <p className="meeting-date">
                    on <strong>{formattedDate}</strong>
                  </p>
                  <p className="meeting-time">
                    at <strong>{startTimeEvent} - {endTimeEvent} {transformedTimeZone}</strong>
                  </p>
                  {showLocalTime && startTimeLocal && endTimeLocal && (
                    <p className="local-time">
                      (at your local time: <strong>{startTimeLocal} - {endTimeLocal}</strong>).
                    </p>
                  )}
                </>
              )}
            </div>
            {!isCancellation && (
              <div className="calendar-invite-content">
                <p className="calendar-invite-text">
                  {BOOKING_MESSAGES.CALENDAR_INVITE_SENT}
                </p>
              </div>
            )}
          </div>
          {isCancellation && (
            <div className="modal-actions">
              <Button
                onClick={onClose}
                className="done-btn"
                label={BOOKING_BUTTON_LABELS.DONE}
                name="done-button"
                type="button"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingSuccessContent;

